export default __webpack_public_path__ + "media/images/equations/regular_order-56b117c70f993f5e876f4e025e91dec1.png";